import type { FunctionComponent } from "react";
import { DashboardLayout } from "../../components/dashboard-layout.components";

export const BrandLayoutBrandScreen: FunctionComponent = () => {
  return <DashboardLayout />
}